




















import { Component, Prop } from "vue-property-decorator";
import BaseSelectableInputComponent from "./BaseSelectableInputComponent.vue";

@Component({
  components: {},
})
export default class InputRadioCpt extends BaseSelectableInputComponent {
  @Prop({ default: false }) row: boolean;
  @Prop({ default: false }) multiple: boolean;

  onChangedInternal(value: any) {
    this.onChange(value);
  }
}
